import { useState } from 'react';
import { useIsMobileScreen } from '@shared/utils/media/useMediaScreens';
import type { CurationHeroRootProps } from './CurationHero';
import { useEventCallback } from '@shared/utils/hooks/useEventCallback';
import type { CurationWatchVideoCtaClicked } from '../../Catalog.telemetry.types';
import { useCatalogLoggingContext } from '../../Catalog.logging';

export type UseCurationHeroControllerReturn = ReturnType<typeof useCurationHeroController>;

export const useCurationHeroController = (props: CurationHeroRootProps) => {
  const [isDescriptionShown, setIsDescriptionShown] = useState<boolean>(false);
  const { watchCurationVideoClicked } = useCatalogLoggingContext();

  const onWatchVideoCtaClicked = useEventCallback((method: CurationWatchVideoCtaClicked['method']) => {
    watchCurationVideoClicked({ curationId: props.curationId, curationTitle: props.hero.title, method, page: 'curationDetails' });
  });

  const isMobile = useIsMobileScreen();

  return {
    isMobile,
    isDescriptionShown,
    setIsDescriptionShown,
    onWatchVideoCtaClicked,
  };
};
